<script lang="ts">
import { ThemeNames, ThemeType } from '@goodlifeplus/themes'
import { defineAsyncComponent, defineComponent } from 'vue'

/**
 * The "Home" layout provider.
 */
export default defineComponent({
  components: {
    HomeClubView: defineAsyncComponent(() => import('./HomeClubView.vue')),
    HomeSubscriptionView: defineAsyncComponent(
      () => import('./HomeSubscriptionView.vue')
    ),
    HomeView: defineAsyncComponent(() => import('./HomeView.vue')),
  },
  setup() {
    return {
      ThemeType,
      ThemeNames,
    }
  },
}) as new (...args: any[]) => any // lifted from vue/test-utils
</script>

<template>
  <HomeClubView v-if="$theme.type === ThemeType.Club" />
  <HomeSubscriptionView v-else-if="$theme.name === ThemeNames.TrueNorth" />
  <HomeView v-else />
</template>
